module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "student-life-at-manara.aea804cb.webp" + "?" + Date.now();